import { types, query, params, rawString } from 'typed-graphqlify';
import { gql } from '@apollo/client';
import { Unpacked } from '../../../../../react-app-env';

const _menusInitQuery = (id: string) => ({
  organisations_by_pk: params(
    { id: rawString(id) },
    {
      name: types.string,
      locale: types.string,
      currency: types.string,
    }
  ),
});

type X = Unpacked<typeof _menusInitQuery>;
export type Organisation = X['organisations_by_pk'];

export const menusInitQuery = (id: string) => gql`
  ${query(_menusInitQuery(id))}
`;
